import apiClient from 'services/axios'
import store from 'store'
import keycloak from 'config/keycloak'
// import connect from 'config/ws'

export async function login(email, password) {
  return apiClient
    .post('/auth/login', {
      username: email,
      password,
    })
    .then(response => {
      if (response) {
        const { token } = response.data
        if (token) {
          store.set('accessToken', token)
        }
        store.set('roleUser', user.role);
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}

export async function register(email, password, name) {
  return apiClient
    .post('/auth/register', {
      email,
      password,
      name,
    })
    .then(response => {
      if (response) {
        const { token } = response.data
        if (token) {
          store.set('accessToken', token)
        }
        return response.data
      }
      return false
    })
    .catch(err => console.log(err))
}


export async function keycloakInit() {
  return keycloak.init({ onLoad: 'check-sso' , silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html` })
}


export async function currentAccount() {
  //  await keycloak.init({ onLoad: 'login-required', responseMode: 'query' })
  /* const authenticated = await keycloak.init({ onLoad: 'login-required', responseMode: 'query' })

  if (!authenticated) {
    return false
  } */

  // store.set('accessToken', keycloak.token)
  return apiClient
    .get('/me')
    .then(response => {
      return response.data
    })
}

export async function logout(options={}) {
  return keycloak
    .logout(options)
    .then(() => {
      store.remove('accessToken')
      return true
    })
    .catch(err => console.log(err))
}
